import Vue from 'vue';
import fly from 'flyio';
import userService from '@/service/userService';
import { AppUtil } from '@/utils/app.util';
// 添加请求拦截器
fly.interceptors.request.use((request: any) => {
  // 可以显式返回request, 也可以不返回，没有返回值时拦截器中默认返回request
  const protocol = document.location.protocol;
  if (request.url.startsWith("//")) {
    request.url = protocol + request.url;
  }
  const userInfo = userService.getCookieUser();
  if (AppUtil.isNotEmpty(userInfo)&&AppUtil.isNotEmpty(userInfo.token)) {
    request.headers['SX-TOKEN'] = userInfo.token;
  }
  return request;
});
// 添加响应拦截器，响应拦截器会在then/catch处理之前执行
fly.interceptors.response.use((response: any) => {
  return response.data;
}, async (err: any) => {
  return Promise.resolve(err);
});

Vue.$fly = fly;
window.$fly = fly;

export default fly;
